export default "__VITE_ASSET__CIDK4uh3__"